import Vue from 'vue';
import debuugerPannel from './pannel/';
import VConsole from 'vconsole';
var envChange = new VConsole.VConsolePlugin('envChange', '开发面板');
envChange.on('renderTab', function (callback) {
  var document = window.document;
  var el = document.createElement('div');
  var html = new Vue({
    el: el,
    render: function render(h) {
      return h(debuugerPannel);
    }
  });
  callback(html.$el);
});
window.vConsole.addPlugin(envChange);